export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const MAX_REFRESH_COUNT = 10;
export const TIMEOUT = 300;
export const UNAUTHORIZED = 401;
export const TOO_MANY_REQUESTS = 429;
export const BAD_GATEWAY = 502;
export const INTERNAL_SERVER_ERROR = 500;
export const AUTHORIZATION_HEADER = 'grpc-metadata-authorization';
export const ARS_VERSION_HEADER = 'grpc-metadata-ars-version';
export const SUPPLIER_HEADER = 'grpc-metadata-supplier';
export const ARS_API_VERSION = '3';
export const AGENT_HEADER = 'grpc-metadata-agent';

export const MAIN_WIDTH = 1920;

export const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;
export const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export const WEEKDAYS = [
  'sun',
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
  'sat'
] as const;
export type Weekday = (typeof WEEKDAYS)[number];
export const CALENDAR_ROW = 6;
export const CALENDAR_COL = 7;

export const JAPANESE_LOCALE = 'ja';
export const ENGLISH_LOCALE = 'en';
export const CHINESE_LOCALE = 'zh';
export const TRADITIONAL_CHINESE_LOCALE = 'zt';
export const KOREAN_LOCALE = 'ko';

export type LocaleOption = {
  value: string;
  label: string;
  disabled: boolean;
};

export const LOCALE_OPTIONS = [
  {
    value: ENGLISH_LOCALE,
    label: 'English',
    disabled: false
  },
  {
    value: JAPANESE_LOCALE,
    label: '日本語',
    disabled: false
  },
  {
    value: CHINESE_LOCALE,
    label: '简体中文',
    disabled: false
  },
  {
    value: TRADITIONAL_CHINESE_LOCALE,
    label: '繁體中文',
    disabled: false
  },
  {
    value: KOREAN_LOCALE,
    label: '한국어',
    disabled: false
  }
] as const satisfies readonly LocaleOption[];

export const dateFnsFormatMap = {
  [CHINESE_LOCALE]: 'yyyy年M月',
  [TRADITIONAL_CHINESE_LOCALE]: 'yyyy年M月',
  [JAPANESE_LOCALE]: 'yyyy年M月',
  [KOREAN_LOCALE]: 'yyyy년 M월',
  [ENGLISH_LOCALE]: 'MMMM yyyy'
};

export const dateFnsMonthDayFormatMap = {
  [CHINESE_LOCALE]: 'M月d日',
  [TRADITIONAL_CHINESE_LOCALE]: 'M月d日',
  [JAPANESE_LOCALE]: 'M月d日',
  [KOREAN_LOCALE]: 'M월 d일',
  [ENGLISH_LOCALE]: 'MMMM d'
};

export { HOLIDAYS } from './holidays';

export const DEFAULT_AGENT_ID = import.meta.env.VITE_APP_AGENT_ID || 'triplabo';

function getAgentIdFromUrl(url: URL): string {
  if (url.protocol !== 'https:') {
    return DEFAULT_AGENT_ID;
  }

  const parts = url.hostname.split('.');
  const agentId = parts[0] === 'www' && parts.length > 1 ? parts[1] : parts[0];

  return agentId;
}

// Read from the page's hostname, which a server render does not have: without
// the guard, importing anything from share on the server throws, since nearly
// every module imports these constants. The server falls back to the build-time
// default — the same value an `http:` origin (local dev) already gets. Browser
// behaviour is unchanged.
export const AGENT_ID =
  typeof window === 'undefined'
    ? DEFAULT_AGENT_ID
    : getAgentIdFromUrl(new URL(window.location.href));

export const PRODUCT_STORAGE_KEY = 'product_store';

export * from './allotment';
export * from './country';
export * from './optionUnitRestriction';

export const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export { DEFAULT_LOGIN_METHODS } from './defaultValues';

export const SESSION_ID = 'sessionId';
export const CART_ID = 'cartId';

export const PROMISE_FULFILLED = 'fulfilled' as const;
export const PROMISE_REJECTED = 'rejected' as const;
